import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpRespuesta } from '../models/http-respuesta.interface';
import { UsuarioSesion, Session } from '../models/usuario-sesion.interface';

@Injectable({
  providedIn: 'root'
})
export class SigninService {
  constructor(private httpclient: HttpClient) { }


  signin(email: string, password: string): Observable<HttpRespuesta<Session>> {
    return this.httpclient.post<HttpRespuesta<Session>>(
      environment.api.sigin,
      { email, password }
    );
  }

  recuperarPassword(usuario: string): Observable<any> {
    return this.httpclient.post(
      environment.api.urlbase + 'recuperar-password',
      { usuario }
    );
  }

  resetPassword(usuario: string, nuevaPassword: string): Observable<any> {
    return this.httpclient.post(
      environment.api.urlbase + 'reset-password',
      { usuario, password: nuevaPassword }
    );
  }
}